// src/components/Modal/ModalTermsAcceptance/ModalTermsAcceptance.jsx
import React, { useState } from 'react';
import { Modal, Button, Checkbox, Typography } from 'antd';
import './modalTermsAcceptance.scss';

const { Title, Text } = Typography;

const ModalTermsAcceptance = ({ visible, onAccept, onCancel, loading }) => {
  const [accepted, setAccepted] = useState(false);

  return (
    <Modal
      title={<Title level={3}>Terms of Service & Privacy Policy</Title>}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="accept"
          type="primary"
          disabled={!accepted}
          loading={loading}
          onClick={onAccept}
          className="green-btn"
        >
          Accept & Login
        </Button>,
      ]}
      width={600}
      className="terms-modal"
    >
      <div className="terms-content">
        <Text>
          By continuing to use our service, you agree to our Terms of Service and Privacy Policy.
          Please review these documents carefully before proceeding.
        </Text>
        
        <div className="terms-links">
          <a href="https://www.wrkfloz.net/_files/ugd/d8f992_b7593d655b9d43dca0a39fe1007ca474.pdf" target="_blank" rel="noopener noreferrer">
            View Terms of Service
          </a>
        </div>

        <div className="acceptance-checkbox">
          <Checkbox
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          >
            I have read and agree to the Terms of Service and Privacy Policy
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTermsAcceptance;
